import { graphql } from '@/generated/gql';

export const SOURCING_CASE_CONTACT_QUERY = graphql(/* GraphQL */ `
  query SourcingCaseContact($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        id
        status
        supplier {
          id
          name
          supplierId
          contact {
            id
            internalId
            firstName
            lastName
            email
            language
          }
        }
      }
    }
  }
`);
